module.exports = __webpack_public_path__ + "img/light-cloudy-storm.9bfc6164.svg";